module.exports = __webpack_public_path__ + "img/banner01.7535a246.webp";